import { LOGIN, REGISTRATION } from '../constants/routes';

// TODO: This hooks is no longer need when links are universal. Do not use it anymore and mitigate usage
// Use registration and login links directly
const useAuthLinksByCountry = (): {
	registrationLink: string;
	loginLink: string;
} => {
	return {
		registrationLink: REGISTRATION,
		loginLink: LOGIN,
	};
};

export default useAuthLinksByCountry;
